import { render } from "./spinner.vue?vue&type=template&id=56e1527a&ts=true"
import script from "./spinner.ts?vue&type=script&lang=ts&external"
export * from "./spinner.ts?vue&type=script&lang=ts&external"

import "./spinner.scss?vue&type=style&index=0&lang=scss&external"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__